import React from "react";

export default function UserResponsesTable({ user }) {

    const responses = [
        { id: 1, survey: "Workplace Utilisation", score: 68, time: "21m", date: "12 Jan", status: "Completed" },
        { id: 2, survey: "Moves & Strategy", score: 71, time: "18m", date: "10 Jan", status: "Completed" },
        { id: 3, survey: "Consultancy Feedback", score: "-", time: "-", date: "-", status: "In Progress" }
    ];

    return (
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: "12px" }}>
            <thead>
                <tr style={{ textAlign: "left", borderBottom: "1px solid #ddd" }}>
                    <th>Survey</th>
                    <th>Status</th>
                    <th>Score</th>
                    <th>Time</th>
                    <th>Date</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                {responses.map(function (r) {
                    return (
                        <tr key={r.id} style={{ borderBottom: "1px solid #eee" }}>
                            <td>{r.survey}</td>
                            <td>{r.status}</td>
                            <td>{r.score}</td>
                            <td>{r.time}</td>
                            <td>{r.date}</td>
                            <td style={{ color: "#4c9aff", cursor: "pointer" }}>View</td>
                        </tr>
                    );
                })}
            </tbody>
        </table>
    );
}
